module.exports = __webpack_public_path__ + "550a1c17c91375ed1f98a2b164ce3ae6.svg";